import { setTokens, clearTokens } from './session';

const domain = import.meta.env.VITE_COGNITO_POOL_DOMAIN;
const client_id = import.meta.env.VITE_COGNITO_POOL_CLIENT_ID;
const redirect_uri = import.meta.env.VITE_COGNITO_POOL_REDIRECT_SIGN_IN;
const logout_uri = import.meta.env.VITE_COGNITO_POOL_REDIRECT_SIGN_OUT;

export async function signIn() {
  const url = `https://${domain}/login?response_type=code&client_id=${client_id}&redirect_uri=${redirect_uri}&prompt=login`;
  window.location.replace(url);
}

export async function signOut() {
  const refresh_token = sessionStorage.getItem('refresh_token');

  if (refresh_token) {
    try {
      const headers = new Headers({
        'Content-Type': 'application/x-www-form-urlencoded',
      });

      const params = new URLSearchParams({
        token: refresh_token,
        client_id,
      });

      const response = await fetch(`https://${domain}/oauth2/revoke`, {
        method: 'POST',
        headers,
        body: params,
        redirect: 'follow',
      });
      if (!response.ok) {
        console.warn(
          'Token revocation request returned non-2xx status:',
          response.status,
          response.statusText
        );
      }
    } catch (error) {
      console.error('Token revocation failed:', error);
    }
  }

  clearTokens();
  window.location.replace(
    `https://${domain}/logout?client_id=${client_id}&logout_uri=${logout_uri}&response_type=code`
  );
}

export async function getTokens(code, refresh_token) {
  const grant_type = code ? 'authorization_code' : 'refresh_token';

  const headers = new Headers({
    'Content-Type': 'application/x-www-form-urlencoded',
  });

  const params = new URLSearchParams({
    grant_type,
    code,
    refresh_token,
    client_id,
    redirect_uri,
  });

  const requestOptions = {
    method: 'POST',
    headers,
    body: params,
    redirect: 'follow',
  };

  try {
    const response = await fetch(
      `https://${domain}/oauth2/token`,
      requestOptions
    );
    if (!response.ok) {
      throw new Error(`Error: ${response.status} ${response.statusText}`);
    }
    const { id_token, access_token, refresh_token } = await response.json();

    setTokens(id_token, access_token, refresh_token);
  } catch (error) {
    console.error('Failed to set tokens:', error);
  }
}

export async function isAuthenticated() {
  const access_token = sessionStorage.getItem('access_token');
  if (!access_token) return false;

  const headers = new Headers({
    Authorization: `Bearer ${access_token}`,
  });

  const requestOptions = {
    method: 'GET',
    headers,
    redirect: 'follow',
  };

  try {
    const response = await fetch(
      `https://${domain}/oauth2/userInfo`,
      requestOptions
    );
    if (!response.ok) {
      throw new Error(`Error: ${response.status} ${response.statusText}`);
    }
    const { email } = await response.json();
    return !!email;
  } catch (error) {
    console.error('Authentication check failed:', error);
    return false;
  }
}
